import { watch } from 'vue'

import { useTeamStore } from '@/pinia/useTeamStore'
import { useBillingInfoLoader } from '@/modules/Billing/useBillingInfoLoader'
import { useMembershipStore } from '@/modules/Teams/useMembershipStore'

export const useMembershipLoader = (): void => {
  const teamStore = useTeamStore()
  const membershipStore = useMembershipStore()
  const billingInfoLoader = useBillingInfoLoader()

  watch(
    () => teamStore.currentTeam,
    () => {
      if (!teamStore.currentTeam) {
        return
      }

      Promise.all([
        membershipStore.loadMemberships(teamStore.currentTeam.slug),
        membershipStore.loadPartnerMemberships(teamStore.currentTeam),
        billingInfoLoader.load(teamStore.currentTeam.id),
      ])
    },
    { immediate: true },
  )
}
